export default {
    "name": "InventoryAllocations",
    "kind": "HoudiniQuery",
    "hash": "bb9d2fd91202100100fb865b53c11a0a5ea34d88d22435507fc0d3a47caab3ff",

    "raw": `query InventoryAllocations($inventoryId: UInt!) {
  inventory(id: $inventoryId) {
    allocations {
      salesOrderLines {
        items {
          id
          description
          quantity
          salesOrder {
            id
            date
            expirationDate
            store {
              id
            }
            documentType {
              id
              name
            }
            salesperson {
              name
              firstName
              lastName
              id
            }
            shippingAddress {
              company
            }
          }
        }
      }
      jobParts {
        id
        quantity
        job {
          id
          workOrder {
            workOrderId
            date
            address {
              company
            }
            store {
              id
              name
            }
            user {
              name
              id
            }
            id
          }
        }
      }
      transferOrderLines {
        id
        quantity
        quantityReceived
        transferOrder {
          id
          date
          store {
            id
          }
          destinationStore {
            id
            name
          }
          user {
            firstName
            lastName
            id
          }
        }
      }
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventory": {
                "type": "Inventory",
                "keyRaw": "inventory(id: $inventoryId)",

                "selection": {
                    "fields": {
                        "allocations": {
                            "type": "InventoryAllocations",
                            "keyRaw": "allocations",

                            "selection": {
                                "fields": {
                                    "salesOrderLines": {
                                        "type": "SalesOrderLineList",
                                        "keyRaw": "salesOrderLines",

                                        "selection": {
                                            "fields": {
                                                "items": {
                                                    "type": "SalesOrderLine",
                                                    "keyRaw": "items",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "description": {
                                                                "type": "String",
                                                                "keyRaw": "description",
                                                                "visible": true
                                                            },

                                                            "quantity": {
                                                                "type": "Decimal6",
                                                                "keyRaw": "quantity",
                                                                "visible": true
                                                            },

                                                            "salesOrder": {
                                                                "type": "SalesOrder",
                                                                "keyRaw": "salesOrder",

                                                                "selection": {
                                                                    "fields": {
                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "date": {
                                                                            "type": "Date",
                                                                            "keyRaw": "date",
                                                                            "visible": true
                                                                        },

                                                                        "expirationDate": {
                                                                            "type": "Date",
                                                                            "keyRaw": "expirationDate",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        },

                                                                        "store": {
                                                                            "type": "Store",
                                                                            "keyRaw": "store",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "documentType": {
                                                                            "type": "SalesOrderDocument",
                                                                            "keyRaw": "documentType",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    },

                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "salesperson": {
                                                                            "type": "UserAccount",
                                                                            "keyRaw": "salesperson",
                                                                            "nullable": true,

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    },

                                                                                    "firstName": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "firstName",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "lastName": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "lastName",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "id": {
                                                                                        "type": "Int",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "shippingAddress": {
                                                                            "type": "Address",
                                                                            "keyRaw": "shippingAddress",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "company": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "company",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "jobParts": {
                                        "type": "JobPart",
                                        "keyRaw": "jobParts",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "quantity": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "quantity",
                                                    "visible": true
                                                },

                                                "job": {
                                                    "type": "Job",
                                                    "keyRaw": "job",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "workOrder": {
                                                                "type": "WorkOrder",
                                                                "keyRaw": "workOrder",

                                                                "selection": {
                                                                    "fields": {
                                                                        "workOrderId": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "workOrderId",
                                                                            "visible": true
                                                                        },

                                                                        "date": {
                                                                            "type": "Date",
                                                                            "keyRaw": "date",
                                                                            "visible": true
                                                                        },

                                                                        "address": {
                                                                            "type": "Address",
                                                                            "keyRaw": "address",
                                                                            "nullable": true,

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "company": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "company",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "store": {
                                                                            "type": "Store",
                                                                            "keyRaw": "store",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    },

                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "user": {
                                                                            "type": "UserAccount",
                                                                            "keyRaw": "user",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    },

                                                                                    "id": {
                                                                                        "type": "Int",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "transferOrderLines": {
                                        "type": "TransferOrderLine",
                                        "keyRaw": "transferOrderLines",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "quantity": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "quantity",
                                                    "visible": true
                                                },

                                                "quantityReceived": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "quantityReceived",
                                                    "visible": true
                                                },

                                                "transferOrder": {
                                                    "type": "TransferOrder",
                                                    "keyRaw": "transferOrder",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "date": {
                                                                "type": "Date",
                                                                "keyRaw": "date",
                                                                "visible": true
                                                            },

                                                            "store": {
                                                                "type": "Store",
                                                                "keyRaw": "store",

                                                                "selection": {
                                                                    "fields": {
                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "destinationStore": {
                                                                "type": "Store",
                                                                "keyRaw": "destinationStore",

                                                                "selection": {
                                                                    "fields": {
                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "name": {
                                                                            "type": "String",
                                                                            "keyRaw": "name",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "user": {
                                                                "type": "UserAccount",
                                                                "keyRaw": "user",

                                                                "selection": {
                                                                    "fields": {
                                                                        "firstName": {
                                                                            "type": "String",
                                                                            "keyRaw": "firstName",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        },

                                                                        "lastName": {
                                                                            "type": "String",
                                                                            "keyRaw": "lastName",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "Int",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "inventoryId": "UInt"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=fc792044cfa7c4e5e55717f703b7c045027864115824b0b42019a2ae7eae5891";